
import createjs, { Point, Shape } from 'createjs-module'

import {Dictionary} from '../../../globals'




export class CanvasMouseTracker {

    private _stage: createjs.Stage | null = null;
    private _imagesDtos: Dictionary<MouseDto> | null = null;

    constructor(stage: createjs.Stage) {
        this._stage = stage;

        this._imagesDtos = {};

        this._stage.addEventListener("stagemousemove", (event: any) => 
        {
            let keys = Object.keys(this._imagesDtos!);
            for (let i = 0; i < keys.length; i++) 
            {
                const key = keys[i];
                let dto = this._imagesDtos![key]

                if(!dto) {
                    continue;
                }

                if(this._currentForcedMouseIcon && this._currentForcedMouseIcon.id !== dto.id) 
                {
                    if(dto.bitmap!.parent) {
                        dto.bitmap!.parent.removeChild(dto.bitmap!)
                    }
                    continue;
                }

                if(!dto.show) {
                    if(dto.bitmap!.parent) {
                        dto.bitmap!.parent.removeChild(dto.bitmap!)
                    }
                    continue;
                }

                let mouseX = event.stageX
                let mouseY = event.stageY

                if(!dto.trackedObject) {

                    if(!dto.bitmap!.parent) {
                        this._stage!.addChild(dto.bitmap!)
                    }
                    
                    dto.bitmap!.x = mouseX;
                    dto.bitmap!.y = mouseY;
                }
                else {                 

                    if(!this.isAttachedToStageTree(dto.trackedObject)){
                        // if trackedObject is not part of the stage tree => dont show the cursor
                        continue;
                    }

                    let coordinates = this.getPositionRelativeToStage(dto.trackedObject);

                    if(this.isInsideTrackedObject(dto.trackedObject, mouseX, mouseY)) {
                        if(!dto.bitmap!.parent) {
                            if(dto.trackedObject.visible) {
                                this._stage!.addChild(dto.bitmap!)
                            }
                        }
                        dto.bitmap!.x = coordinates.x + (dto.trackedObject.getBounds().width - dto.bitmap!.getBounds().width) * 0.5;
                        dto.bitmap!.y = coordinates.y + (dto.trackedObject.getBounds().height - dto.bitmap!.getBounds().height) * 0.5;
                    }
                    else {
                        if(dto.bitmap!.parent) {
                            this._stage!.removeChild(dto.bitmap!)
                        }
                    }
                    
                }
            }

            stage.update();
        })

        //
        setInterval(() => 
        {
            let keys = Object.keys(this._imagesDtos!);
            for (let i = 0; i < keys.length; i++) 
            {
                const key = keys[i];
                let dto = this._imagesDtos![key]

                if(!dto) {
                    continue;
                }

                if(dto.trackedObject) 
                {
                    if(!dto.trackedObject.visible) 
                    {
                        if(dto.bitmap!.parent) 
                        {
                            dto.bitmap!.parent.removeChild(dto.bitmap!)

                            // re-render the stage only if something have changed
                            stage.update();
                        }
                    }
                }
            }

        }, 300);
    }

    
    isAttachedToStageTree(trackedObject: createjs.DisplayObject) {

        // if we belong to the stage tree => most top parent is the stage

        let currentParent = trackedObject.parent

        while(currentParent) {
            currentParent = currentParent.parent;

            if(currentParent === this._stage) {
                return true;
            }
        }

        return false;
    }

    getPositionRelativeToStage(trackedObject: createjs.DisplayObject){
        let x0 = trackedObject.x;
        let y0 = trackedObject.y;

        let currentParent = trackedObject.parent

        while(currentParent !== trackedObject.stage) {
            x0 += currentParent.x;
            y0 += currentParent.y;
            currentParent = currentParent.parent;
        }
        return new Point(x0, y0)
    }

    isInsideTrackedObject(trackedObject: createjs.DisplayObject, mouseX: number, mouseY: number): boolean {
        
        let dimensions = trackedObject.getBounds();
        let coordinates = this.getPositionRelativeToStage(trackedObject);

        if(mouseX >= coordinates.x && mouseX <= coordinates.x + dimensions.width &&
           mouseY >= coordinates.y && mouseY <= coordinates.y + dimensions.height      )
        { 
            return true;
        }

        return false;
    }

    public addMouseIcon(id: string, url: string, trackedObject: createjs.DisplayObject | null= null, onIconReadyCallback?: Function){
        
        if(this._imagesDtos![id]) {
            console.warn(`CanvasMouseTracker:: addMouseIcon(): icon id:${id} already exist`)
            return;
        }
        
        let image = new Image();
        image.src = url
        image.onload = () => {

            let dto =  new MouseDto();
            dto.id = id;
            dto.imageUrl = url;
            dto.image = image;
            dto.bitmap = new createjs.Bitmap(image);
            dto.trackedObject = trackedObject;

            this._imagesDtos![id] = dto

            if(onIconReadyCallback) {
                onIconReadyCallback();
            }
        };
    }

    private _currentForcedMouseIcon: MouseDto | null = null;

    public showMouseIcon(id: string, force: boolean = false){

        let nextIcon = this._imagesDtos![id]

        if(nextIcon) {
            nextIcon.show = true;
            nextIcon.force = force;
            if(force){
                this._currentForcedMouseIcon = nextIcon;
            }
            else {
                this._currentForcedMouseIcon = null;
            }

            if(!nextIcon.trackedObject) {
                // if no tracked object => we want to show the mouse icon immediately
                this.setCursor('none');
            }
        }
    }

    public setIconForce(id: string, force: boolean){
        if(this._imagesDtos![id]){
            this._imagesDtos![id].force = force;
        }
    }

    public hideIcon(id: string){
        
        const dto  = this._imagesDtos![id];
        if(dto) {
            if(dto.bitmap!.parent) {
                dto.bitmap!.parent.removeChild(dto.bitmap!)
            }
            dto.show = false;
            dto.force = false;

            if(this._currentForcedMouseIcon && this._currentForcedMouseIcon.id === dto.id) {
                this._currentForcedMouseIcon = null;
            }

            this._stage?.update();

            this.setCursor('');
        }
    }

    public deleteIcon(id: string){

    }

    public hideAllIcon(){
        
        let keys = Object.keys(this._imagesDtos!);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const dto  = this._imagesDtos![key];
            if(dto.bitmap!.parent) {
                dto.bitmap!.parent.removeChild(dto.bitmap!)
            }
            dto.show = false;
        }

        this._stage?.update();

        this.setCursor('');
    }

    // possible options
    // https://stackoverflow.com/questions/3087975/how-to-change-the-cursor-into-a-hand-when-a-user-hovers-over-a-list-item
    public showMouseCursor(cursor: string){
        this.hideIcon(cursor);
        this.setCursor(cursor);
    }

    public hideMouseCursor(){
        this.setCursor('');
    }

    private setCursor(value: string){
        let stageAny: any = this._stage!;
        stageAny.canvas.style.cursor = value
    }

    public dispose() {
        
    }
}

export class MouseDto {
    id?: string;
    imageUrl?: string;
    image?: HTMLImageElement;
    bitmap?: createjs.Bitmap;
    trackedObject?: createjs.DisplayObject | null;
    show: boolean = false;
    force: boolean = false;
}

